import { useEffect, useState } from 'react';


import { Row, Col, Button, Progress } from 'antd';
import AbacusView from '../../base/abacus';
import Result from '../../base/result';
import { generateRandomSubs, generateRandomSums, getSeriesFromCouples, shuffle } from '../../../utils';

import './index.less';
import { t } from '../../../languages';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import Crunker from 'crunker';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';

const ExercisePresentation = ({ lang, video, onFinish }) => {

    const messagestyle = 0;

    return <>
        <Col span={24} className="exercise-body">
            <ExerciseBlocker show={messagestyle} />
            <section className="mentalcalculus">
                <video
                    src={video}
                    muted={false}
                    autoPlay={true}
                    controls={false}
                    onEnded={onFinish}
                    onError={() => console.log('onError...')}
                    onClick={() => console.log('onClick...')}
                    style={{ width: 'auto', height: '50vh' }}
                    poster={`./static/koyu/welcome_mental_calculus.jpg`}
                />
            </section>
        </Col>
    </>
}

const AudioTutor = ({ voicesrc, onFinish }) => {
    const [audioEnded, setAudioEnded] = useState(false);

    const handleEnded = () => {
        setAudioEnded(true);
        if (onFinish) onFinish()
    }

    return <article className='audio-tutor'>
        <div className='wave'>
            <span>{audioEnded ? null : <img alt="wave" src={'./static/utils/voicewave.gif'} />}</span>
            <span className='tutor'><img alt="koyu" src={'./static/koyu/koyu_mental_calculus.jpg'} /></span>
        </div>
        <div className='audio'><audio src={voicesrc} controls={false} autoPlay={true} onEnded={handleEnded} /></div>
    </article>
}

let abTimeout;
const SetAbacus = ({ lang, value, rows, voice, onFinish }) => {
    const [moved, setMoved] = useState(0);
    const [numberinbox, setNumberinbox] = useState(0);
    const [message, setMessage] = useState(null);
    const [result, setResult] = useState([]);

    useEffect(() => {
        if (!value) setMoved(1);
        return () => { clearTimeout(abTimeout) };
    }, []);

    const handleChange = (num) => {
        setNumberinbox(parseInt(num));
        setMoved(1);
    }

    const validateHandle = () => {
        if (!value) {
            onFinish();
        } else {
            let message = value ? `${t(lang, 'rightanswer')}` : null;
            if (numberinbox === value) {
                setResult(1);
            } else {
                setResult(0);
                message = `${t(lang, 'yourwrong')} ${value}`
            }

            setMessage(message);
        }
    }

    const handleNext = () => {
        onFinish(result);
    }

    const stillrows = !value ? Array.from(Array(rows).keys()) : [];

    const locparams = { rows, number: 0, number: numberinbox, stillrows };

    const messagestyle = message ? (!result ? ' error' : ' valid') : '';

    return <>
        <Col span={24} className="exercise-body">
            <section className="mentalcalculus">
                <AudioTutor voicesrc={voice} />
                <article>
                    <AbacusView params={locparams} isactive={true} hidelatframe={true} hideheaderlabels={true} onChange={handleChange} />
                </article>
            </section>
        </Col>

        <Col span={24} className={'botonera'}>
            <Row className={'botones' + messagestyle}>
                <Col span={24} className={'message'}>{message}</Col>
                <Col span={24}>
                    {message ? null : <Button key="submit" disabled={!moved} type="primary" onClick={validateHandle} style={{ 'width': '90%' }}>{t(lang, value ? 'grade' : 'ready')}</Button>}
                    {message ? <Col span={24}><Button key="submit" type="primary" onClick={handleNext} style={{ 'width': '90%' }}>{t(lang, 'next')}</Button></Col> : null}
                </Col>
            </Row>
        </Col>
    </>
}


const Guide = ({ lang, operation, onFinish, is_test }) => {

    const [theAudio, setTheAudio] = useState(null);

    const c_path = `./static/voices/${lang}/calculus`;
    const cc_path = `./static/voices/common`;
    const n_path = `./static/voices/${lang}/numbers`;

    useEffect(() => {
        generateAudioSecuence(operation);
    }, []);

    const gen_plus_seq = (num1, num2) => {
        const seq = [];
        seq.push(`${cc_path}/mute60.mp3`);
        seq.push(...gen_number(num1));
        seq.push(`${c_path}/plus.mp3`);
        seq.push(...gen_number(num2));
        seq.push(`${cc_path}/mute60.mp3`);
        return seq;
    }

    const gen_sub_seq = (num1, num2) => {
        const seq = [];
        seq.push(`${cc_path}/mute60.mp3`);
        seq.push(...gen_number(num1));
        seq.push(`${c_path}/minus.mp3`);
        seq.push(...gen_number(num2));
        seq.push(`${cc_path}/mute60.mp3`);
        return seq;
    }

    const gen_number = (numsrt) => {
        const num = parseInt(numsrt);
        const num_seq = [];

        if (num < 20) {
            num_seq.push(`${n_path}/${num}.mp3`);
        } else if (num >= 20 && num < 100 && num % 10 == 0) {
            num_seq.push(`${n_path}/${num}.mp3`);
        } else if (num >= 100 && num < 1000 && num % 100 == 0) {
            num_seq.push(`${n_path}/${num}.mp3`);
        } else if (num >= 1000 && num < 10000 && num % 1000 == 0) {
            num_seq.push(`${n_path}/${num}.mp3`);
        } else {
            const digits = numsrt.split('');

            for (let idx = 0; idx < digits.length; idx++) {
                const aDigit = parseInt(digits[idx]);
                const rem_number = parseInt(digits.slice(idx, digits.length).join(''));

                if (rem_number > 0 && rem_number < 20) {
                    num_seq.push(`${n_path}/${rem_number}.mp3`);
                    break;
                } else if (rem_number >= 20 && rem_number < 100 && rem_number % 10 == 0) {
                    num_seq.push(`${n_path}/${rem_number}.mp3`);
                    break;
                } else if (rem_number >= 100 && rem_number < 1000 && rem_number % 100 == 0) {
                    num_seq.push(`${n_path}/${rem_number}.mp3`);
                    break;
                } else {
                    const pot = Math.pow(10, digits.length - idx - 1);
                    const pnum = `${parseInt(aDigit) * pot}${pot === 100 && aDigit === 1 ? 'to' : ''}${pot === 10 ? 'i' : ''}`;
                    if (pnum != 0) num_seq.push(`${n_path}/${pnum}.mp3`);
                }
            }

        }

        return num_seq;
    }

    const generateAudioSecuence = (operation) => {
        // console.log('generateAudioSecuence operation:', operation);
        const op_parts = operation.split(/(\+|-|\*|\/)/sg);

        const num1 = op_parts[0].trim();
        const op = op_parts[1].trim();
        const num2 = op_parts[2].trim();
        const result = eval(operation);
        const digits1 = num1.split('');
        const digits2 = num2.split('');

        // console.log('generateAudioSecuence op_parts:', op_parts, '::', result);

        const audio_seq = [
            `${c_path}/0.close_eyes.mp3`,
            `${cc_path}/mute60.mp3`,
            (is_test ? `${c_path}/1.set.mp3` : `${c_path}/1.movingset.mp3`),
            ...gen_number(num1),
            `${cc_path}/mute180.mp3`,
        ];

        if (op === '+') {
            audio_seq.push(`${c_path}/2.nowadd.mp3`);
            audio_seq.push(...gen_number(num2));
            audio_seq.push(`${cc_path}/mute60.mp3`);

            if (result < 10) {
                if (!is_test) audio_seq.push(`${c_path}/3.movefingerstoadd.mp3`);
            } else if (result < 20) {
                if (!is_test) audio_seq.push(`${c_path}/3.movefingerstoadd.mp3`);
            } else if (result < 100) {
                if (digits1.length > digits2.length) {
                    audio_seq.push(`${cc_path}/mute180.mp3`);
                } else {
                    if (!is_test) {
                        audio_seq.push(`${cc_path}/mute60.mp3`);
                        audio_seq.push(`${c_path}/4.first10s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[0], digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[1], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            } else if (result < 1000) {
                audio_seq.push(`${cc_path}/mute60.mp3`);
                if (digits1.length > digits2.length) {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/4.first10s.mp3`);
                        const decs = digits1[0] + digits1[1];
                        audio_seq.push(...gen_plus_seq(decs, digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[2], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                } else {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/5.first100s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[0], digits2[0])); audio_seq.push(`${cc_path}/mute60.mp3`);
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[1], digits2[1])); audio_seq.push(`${cc_path}/mute60.mp3`);
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[2], digits2[2])); audio_seq.push(`${cc_path}/mute60.mp3`);
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            } else {
                audio_seq.push(`${cc_path}/mute60.mp3`);
                if (digits1.length > digits2.length) {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/5.first100s.mp3`);
                        const cents = digits1[0] + digits1[1];
                        audio_seq.push(...gen_plus_seq(cents, digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[2], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[3], digits2[2]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                } else {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/6.first1000s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[0], digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/6.now100s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[1], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[2], digits2[2]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_plus_seq(digits1[3], digits2[3]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            }

        } else if (op === '-') {
            audio_seq.push(`${c_path}/2.nowsub.mp3`);
            audio_seq.push(...gen_number(num2));
            audio_seq.push(`${cc_path}/mute60.mp3`);

            if (num1 < 10) {
                if (!is_test) audio_seq.push(`${c_path}/3.movefingerstosub.mp3`);
            } else if (num1 < 20) {
                if (!is_test) audio_seq.push(`${c_path}/3.movefingerstosub.mp3`);
            } else if (num1 < 100) {
                if (digits1.length > digits2.length) {
                    audio_seq.push(`${cc_path}/mute180.mp3`);
                } else {
                    if (!is_test) {
                        audio_seq.push(`${cc_path}/mute60.mp3`);
                        audio_seq.push(`${c_path}/4.first10s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[0], digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[1], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            } else if (result < 1000) {
                audio_seq.push(`${cc_path}/mute60.mp3`);
                if (digits1.length > digits2.length) {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/4.first10s.mp3`);
                        const decs = digits1[0] + digits1[1];
                        audio_seq.push(...gen_sub_seq(decs, digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[2], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                } else {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/5.first100s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[0], digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[1], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[2], digits2[2]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            } else {
                audio_seq.push(`${cc_path}/mute60.mp3`);
                if (digits1.length > digits2.length) {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/5.first100s.mp3`);
                        const cents = digits1[0] + digits1[1];
                        audio_seq.push(...gen_sub_seq(cents, digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[2], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[3], digits2[2]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                } else {
                    if (!is_test) {
                        audio_seq.push(`${c_path}/6.first1000s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[0], digits2[0]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/6.now100s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[1], digits2[1]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/5.now10s.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[2], digits2[2]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                        audio_seq.push(`${c_path}/4.nowunits.mp3`);
                        audio_seq.push(...gen_sub_seq(digits1[3], digits2[3]));
                        audio_seq.push(`${cc_path}/mute180.mp3`);
                    } else { audio_seq.push(`${cc_path}/mute240.mp3`); }
                }
            }

        }

        audio_seq.push(`${cc_path}/mute120.mp3`);
        audio_seq.push(`${c_path}/x.whatnumber.mp3`);
        audio_seq.push(`${cc_path}/mute120.mp3`);

        // console.log('generateAudioSecuence audio_seq:', audio_seq);

        concatAudios(audio_seq).then((anAudio) => {
            setTheAudio(anAudio.url);
        })

    }


    const handleFinish = () => {
        if (onFinish) onFinish()
    }

    return <>
        <Col span={24} className="exercise-body">
            <section className="mentalcalculus">
                {theAudio ? <AudioTutor voicesrc={theAudio} onFinish={handleFinish} /> : null}
                <article className='closed_eyes'><img src='./static/utils/closed_eyes.png' /></article>
            </section>
        </Col>
    </>

}

const concatAudios = async (audioList) => {
    const crunker = new Crunker();

    return await crunker
        .fetchAudio(...audioList)
        .then((buffers) => crunker.concatAudio(buffers))
        .then((merged) => crunker.export(merged, 'audio/mp3'))
        // .then((output) => crunker.download(output.blob))
        .catch((error) => {
            throw new Error(error);
        });

    /* crunker.notSupported(() => {
        // Handle no browser support
        console.log('concatAudios NO SUPPORTED');
    }); */

}

const getConfigStep = (step, lang, aVal) => {

    const OPTIONS = {
        WELCOME_MENTAL_CALCULUS: { type: 'presentation', video: `./static/koyu/${lang}/welcome_mental_calculus.mp4` }, // video
        OBSERVE_ABACUS: { type: 'set_number', voice: `./static/voices/${lang}/calculus/a.observe_abacus.mp3`, value: 0 },  // audio
        OPEN_AND_SET: { type: 'set_number', 'voice': `./static/voices/${lang}/calculus/z.open_and_set.mp3`, value: aVal }, // audio
        TRY_ANOTHER_CALC: { type: 'presentation', video: `./static/koyu/${lang}/try_another_calc.mp4` }, // video
    }

    return OPTIONS[step];

}


const MentalCalculus = ({ lang, params, uid, eid, saveResult, handleCancel }) => {

    const [series, setSeries] = useState([]);
    const [scouples, setScouples] = useState([]);
    const [current, setCurrent] = useState(0);
    const [results, setResults] = useState([]);
    const [times, setTimes] = useState([]);


    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);

    const [ready, setReady] = useState(false);
    const [showresults, setShowresults] = useState(false);

    const [initMoment, setInitMoment] = useState(0);


    useEffect(() => {
        setInitMoment(moment());
        handleRepeat();
    }, []);

    const handleRepeat = () => {
        // const scouples = getSeriesFromCouples(params.couples, params.num, params.init, params.finish, params.ops, params.config, params.ispan, params.fspan, params.lowerlimit, params.upperlimit, params.startwith0);

        const is_test = params.is_test || false;

        let scouples;

        if (params.couples == 'random') {
            if (params.ops[0] === '+') scouples = generateRandomSums(params.num, params.init, params.lowerlimit, params.upperlimit);
            if (params.ops[0] === '-') scouples = generateRandomSubs(params.num, params.init, params.lowerlimit, params.upperlimit);
        } else scouples = shuffle(params.couples).slice(0, params.num);

        const series = scouples.map((aC, idx) => {
            let res_sequence = [];

            if (!is_test) {
                if (idx === 0) res_sequence.push(getConfigStep('WELCOME_MENTAL_CALCULUS', lang));
                else res_sequence.push(getConfigStep('TRY_ANOTHER_CALC', lang));
            }

            res_sequence.push(getConfigStep('OBSERVE_ABACUS', lang));
            res_sequence.push({ type: 'guide', operation: aC });
            res_sequence.push(getConfigStep('OPEN_AND_SET', lang, parseInt(eval(aC))));

            return res_sequence;
        });

        // console.log('MentalCalculus scouples:', scouples);

        setScouples(scouples);
        setSeries(series);
        setCurrent(0);
        setSteps(series[0]);
        setCurrentStep(0);

        setResults([]);

        setShowresults(false);
    }

    const handleNextStep = (result) => {
        if ((currentStep + 1) >= steps.length) {
            results.push(result);
            setResults(results);

            handleNext();
        } else {
            setCurrentStep(currentStep + 1)
        }
    }

    const handleNext = () => {

        if (current < series.length - 1) {
            setCurrent(current + 1);
            setSteps(series[current + 1])
            setCurrentStep(0);

        } else {
            const num = params.num;
            const hits = results.reduce((acc, aR) => acc += aR);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            saveResult(uid, `${uid}-${eid}`, { id: 'MC', uid, eid, p: passed, h: hits, e: errors, c: (passed ? coins : 0), r: results, s: scouples, et: elapsedTime });
            setShowresults(true);
        }
    }


    /* To render */
    const currentStepObj = steps[currentStep];
    // console.log('MentalCalculus currentStepObj:', currentStepObj);
    // console.log('MentalCalculus results:', results);
    const rate = results[current];
    const percent = parseInt((current) / params.num * 100);

    const is_test = params.is_test || false;
    // console.log('MentalCalculus is_test:', is_test);

    const stillrows = !ready ? Array.from(Array(params.rows).keys()) : [];

    if (!showresults && currentStepObj) {
        return (
            <Row className="exercise">
                <BackMusic source={'gamelan_2.mp3'} />
                <ChangeOrientation to={'portrait'} />

                {!is_test ? <Col span={21} className='progress-bar'>
                    <Progress percent={percent} showInfo={false} />
                </Col> : null}

                {currentStepObj.type === 'presentation' ? <ExercisePresentation lang={lang} video={currentStepObj.video} onFinish={handleNextStep} /> : null}
                {currentStepObj.type === 'set_number' ? <SetAbacus lang={lang} rows={params.rows} value={currentStepObj.value} voice={currentStepObj.voice} onFinish={handleNextStep} /> : null}
                {currentStepObj.type === 'guide' ? <Guide lang={lang} operation={currentStepObj.operation} onFinish={handleNextStep} is_test={is_test} /> : null}
            </Row>
        );
    } else {
        return (
            <Result params={params} results={results} handleRepeat={handleRepeat} handleCancel={handleCancel} lang={lang} />
        );
    }


}

export default MentalCalculus;

